import neo4j from '@/api/neo4j'
import { storage } from '@/api/firebase'

export default {
  async get (id) {
    const query = [
      `MATCH (node)`,
      'WHERE ID(node) = {id}',
      'RETURN node'
    ].join('\n')
    const params = {
      id
    }
    return neo4j.cypher({
      query,
      params
    })
      .then((response) => {
        return response.map(r => r.node)
      })
      .then((response) => {
        return response.length > 0 ? response[0] : null
      })
      .then(async (model) => {
        // process file url if not exits
        const storageRef = storage.ref()
        // console.log(model)
        if (model && model.properties.files) {
          let files = {}
          try {
            files = JSON.parse(model.properties.files)
          } catch (e) {
          }
          let shouldUpdate = false
          for (const key of Object.keys(files)) {
            const file = files[key]
            if (!file.url) {
              shouldUpdate = true
              let url = null
              try {
                url = await storageRef.child(file.path).getDownloadURL()
              } catch (e) {
                if (e.code && e.code === 'storage/object-not-found') {
                  delete files[key]
                }
              }
              file.url = url
              console.log(url)
            }
          }
          if (shouldUpdate) {
            model.properties.files = JSON.stringify(files)
            await this.updateProps(id, model.properties)
          }
        }
        return model
      })
  },
  getAll (type, { page = 1, limit = 10, keyword = '', order = 'name' }) {
    const offset = (page - 1) * limit
    let query = [
      `MATCH (node:${type})`
    ]
    if (keyword !== '') {
      query.push(`WHERE node.name CONTAINS '${keyword}'`)
    }
    query.push('RETURN node')
    query.push(`ORDER BY node.${order}`)
    query.push(`SKIP ${offset}`)
    query.push(`LIMIT ${limit}`)
    query = query.join('\n')
    const params = {}
    return neo4j.cypher({
      query,
      params
    })
      .then((response) => {
        return response.map(r => r.node)
      })
      // .then((response) => {
      //   return response.reduce((map, object) => {
      //     map[object._id] = object
      //     return map
      //   }, {})
      // })
  },
  autocomplete (keyword = '', limit = 10) {
    let query = [
      `MATCH (node)`
    ]
    query.push(`WHERE node.name CONTAINS '${keyword}'`)

    query.push('RETURN node.name as name, id(node) as _id, labels(node) as labels')
    query.push('ORDER BY node.name')
    query.push(`LIMIT ${limit}`)
    query = query.join('\n')
    const params = {}
    return neo4j.cypher({
      query,
      params
    })
      .then((response) => {
        return response
      })
  },
  countAll (type, keyword = '') {
    let query = [
      `MATCH (node:${type})`
    ]
    if (keyword !== '') {
      query.push(`WHERE node.name CONTAINS '${keyword}'`)
    }
    query.push('RETURN count (node) as total')
    query = query.join('\n')
    const params = {}
    return neo4j.cypher({
      query,
      params
    })
      .then((response) => {
        return response[0].total
      })
  },
  async updateProps (id, props) {
    const query = [
      `MATCH (node)`,
      'WHERE ID(node) = {id}',
      'SET node = $props',
      'RETURN node'
    ].join('\n')
    const params = {
      props: props,
      id
    }
    return neo4j.cypher({
      query,
      params
    })
      .then((response) => {
        return response.map(r => r.node)
      })
  }
}



// WEBPACK FOOTER //
// ./src/models/node.js